module.exports = "/_next/static/images/7d469ee84645adbe2fac1e62a22955b2-roxinho-single-md@1x.jpg";